import { Directive, ElementRef, HostListener } from '@angular/core';
import { normalizeSocialSecurityNumber } from '@app/providers/utils/form-validators';

@Directive({
  selector: '[prSocialSecurityNumber]',
  standalone: false,
})
export class PrSocialSecurityNumberDirective {
  constructor(private el: ElementRef<HTMLInputElement>) {}

  @HostListener('input')
  onInput(): void {
    this.sanitize();
  }

  private sanitize(): void {
    const input = this.el.nativeElement;
    const sanitized = normalizeSocialSecurityNumber(input.value);
    if (input.value === sanitized) {
      return;
    }

    const caret = input.selectionStart ?? input.value.length;
    const keptBeforeCaret = normalizeSocialSecurityNumber(
      input.value.slice(0, caret),
    ).length;

    input.value = sanitized;
    input.setSelectionRange(keptBeforeCaret, keptBeforeCaret);
    input.dispatchEvent(new Event('input'));
  }
}
